export const environment = {
  production: false,
  applicationId: 'demo_app',
  stateServiceEndpoint: 'http://localhost:8080/client-state',
  // http://localhost:8080
  serviceActivatorEndpoint: 'http://localhost:4200/backend',
};
